export default "__VITE_ASSET__CnhYA4Lh__"